module.exports = __webpack_public_path__ + "static/media/bullhorn.4b2c5798.svg";